import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { findMembers, type MemberHit } from "../../api/classes";
import { useServices } from "../../app/services";
import { Field, messageOf, styles as c } from "./common";
import { useScope } from "./common";

/** `GET /members?q=`: two letters or more. The API decides what the member may book, not this picker. */
export function MemberPicker({ onPick, picked }: { onPick: (m: MemberHit) => void; picked?: string | null }) {
  const { client } = useServices();
  const sc = useScope();
  const [text, setText] = useState("");
  const [q, setQ] = useState("");
  useEffect(() => { const t = setTimeout(() => setQ(text.trim()), 200); return () => clearTimeout(t); }, [text]);
  const hits = useQuery({ queryKey: ["members-search", ...sc.key, q], queryFn: ({ signal }) => findMembers(client, q, signal), enabled: q.length >= 2, retry: false });
  return (
    <div className={c.stack}>
      <Field label="Find a member" htmlFor="member-q" hint="Type at least two letters of the name or number.">
        <input id="member-q" className={c.input} value={text} onChange={(e) => setText(e.target.value)} autoComplete="off" />
      </Field>
      {hits.error ? <p className={c.err} role="alert">{messageOf(hits.error)}</p> : null}
      {hits.data && hits.data.length === 0 ? <p className={c.note}>No member matches “{q}”.</p> : null}
      <div role="listbox" aria-label="Members found">
        {(hits.data ?? []).map((m) => (
          <button key={m.id} type="button" role="option" aria-selected={picked === m.id} aria-pressed={picked === m.id} className={c.hit} onClick={() => onPick(m)}>
            <span className={c.trunc} title={m.name}>{m.name}</span>
            {m.phone ? <span className={c.note}> · {m.phone}</span> : null}
          </button>
        ))}
      </div>
    </div>
  );
}
